import { render, staticRenderFns } from "./SelectableBrands.vue?vue&type=template&id=2df9e54e&"
import script from "./SelectableBrands.vue?vue&type=script&lang=ts&"
export * from "./SelectableBrands.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports